import Vue from 'vue';
import VueMeta from 'vue-meta';
import {App, plugin} from '@inertiajs/inertia-vue';
import {InertiaProgress} from '@inertiajs/progress';
import {InertiaForm} from 'laravel-jetstream';
import PortalVue from 'portal-vue';
import VueI18n from 'vue-i18n';
import messages from '@/Shared/translations';
import {library} from '@fortawesome/fontawesome-svg-core';
import {
    faArrowRight,
    faDiceD6,
    faFileInvoiceDollar,
    faGlobeAmericas,
    faHome,
    faGripLinesVertical,
    faPowerOff,
    faMoneyCheck,
    faSignal,
    faShareAlt,
    faSortNumericUp,
    faSortNumericDown,
    faSortAlphaUp,
    faSortAlphaDown,
    faSync,
    faUser,
    faUsers,
    faDesktop,
    faTimes,
    faPrint
} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import {currency} from '@/Shared/filters/currency';
import {formatDate, formatDateTime} from '@/Shared/filters/datetime';
import VueMask from 'v-mask';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import Layout from './Layout';
import bugsnagInit from '../Shared/bugsnag';
import pusherInit from '../Shared/pusher';
import credLoad from '../Shared/credmanager';
import CurrencyPlugin from '../Shared/currencyPlugin';
import GuestLayout from "./GuestLayout";

credLoad.then(credMgr => {
window.credManager = credMgr

pusherInit();

if (process.env.MIX_APP_ENV === 'production') {
    bugsnagInit();
}

library.add({
    faArrowRight,
    faDiceD6,
    faFileInvoiceDollar,
    faGlobeAmericas,
    faHome,
    faGripLinesVertical,
    faPowerOff,
    faMoneyCheck,
    faSignal,
    faSortNumericUp,
    faSortNumericDown,
    faSortAlphaUp,
    faSortAlphaDown,
    faSync,
    faShareAlt,
    faUser,
    faUsers,
    faDesktop,
    faTimes,
    faPrint,
});

Vue.component(VueQrcode.name, VueQrcode);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.mixin({
    methods: {
        route,
        isRoute(...routes) {
            return routes.some(route => this.route().current(route));
        }
    }
});
Vue.use(plugin);
Vue.use(InertiaForm);
Vue.use(VueMask);
Vue.use(PortalVue);
Vue.use(VueI18n);
Vue.use(VueMeta);
Vue.use(CurrencyPlugin);

if (!window.currency) {
    console.error('There is no currency set in global scope `window.currency`');
}
Vue.filter('currency', currency(window.currency));
Vue.filter('date', formatDate);
Vue.filter('datetime', formatDateTime);

InertiaProgress.init();

const i18n = new VueI18n({
    locale: navigator.language.split('-')[0],
    fallbackLocale: 'en',
    messages,
});

axios.defaults.withCredentials = true;

const pos = document.getElementById('app');

new Vue({
    i18n,
    metaInfo: {
        title: '',
        titleTemplate: (title) => title ? `${title} - ${window.appName}` : window.appName
    },
    render: (h) =>
        h(App, {
            props: {
                initialPage: JSON.parse(pos.dataset.page),
                resolveComponent: (name) => {
                    const page = require(`${name}`).default;
                    page.layout = page.layout === undefined ? Layout : page.layout;

                    if (name === './Pages/PosLogin') {
                        page.layout = GuestLayout;
                    }

                    return page;
                }
            },
        }),
}).$mount(pos);

});
